<section class="public-profile team-section">
  <div class="container">
    <div class="container-wrap">
      <div class="bg-wrap">
        <div class="top-ba"></div>

        <div class="profile-wrap" *ngIf="player">
          <div class="ba">
            <img [src]="player && player.banner ? player.banner : ''" width="100%" [alt]="player.first_name" />
          </div>

          <div class="avatar">
            <p>{{'PUBLIC_PROFILE.DONATE_DIRECTLY_TO' | translate}}</p>
            <div class="img-wrap">
              <img [ngSrc]="player && player.avatar ? player.avatar : '../../../assets/images/icons/player.png'" fill loading="lazy" [alt]="player.first_name" />
            </div>
          </div>

          <div class="name">
            <h1>{{player.first_name}} {{player.last_name}}</h1>
          </div>

          <div class="description" *ngIf="!pickupRequestCompleted; else successMessage">
            <p>{{player.description}}</p>
          </div>

          <ng-template #successMessage>
            <div class="description success">
              <h3>{{'PUBLIC_PROFILE.SUCCESS_PLAYER_TITLE' | translate: { first_name: player.first_name } }}</h3>
              <p>{{'PUBLIC_PROFILE.SUCCESS_PLAYER_DESCRIPTION' | translate}}</p>
            </div>
          </ng-template>

          <div class="button-wrap" *ngIf="!pickupRequestCompleted">
            <button class="btn btn-primary"
                    (click)="openPickupRequestForm(false, player)">{{'PUBLIC_PROFILE.DONATE_TO_PLAYER' | translate}} {{player.first_name}}</button>
          </div>

        </div>
      </div>

      <div class="profile-footer">
        <div class="team-info" *ngIf="player && player.team && !pickupRequestCompleted">
          <div class="team-name">
            <a [routerLink]="['/', currentLang, 'teams', player.team.public_id]">
              <h4>{{player && player.club && player.club.name ? player.club.name : ''}} {{player && player.team && player.team.name ? player.team.name : ''}}</h4>
            </a>
          </div>
          <div class="team-avatar-name-wrap">
            <a [routerLink]="['/', currentLang, 'teams', player.team.public_id]" class="team-avatar">
              <img [ngSrc]="player && player.team && player.team.avatar ? player.team.avatar : '../../../assets/images/icons/player.png'" fill loading="lazy"  alt="">
            </a>
            <button class="btn btn-primary" (click)="openPickupRequestForm(true, player)">{{'PUBLIC_PROFILE.DONATE_TO_TEAM' | translate}}</button>
          </div>
        </div>

        <div class="download-app-info">
          <div class="download-app-title">
            <h4>{{'PUBLIC_PROFILE.DOWNLOAD_APP_TITLE' | translate}}</h4>
          </div>
          <div class="buttons-wrap">
            <a [href]="storeLinks.GIPANT.appStore" class="store-btn apple" target="_blank"></a>
            <a [href]="storeLinks.GIPANT.googlePlay" class="store-btn android" target="_blank"></a>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<ngx-smart-modal #pickupRequestModal identifier="pickupRequestModal" [customClass]="'pickup-request-modal'" [dismissable]="false">
  <app-pickup-request-form *ngIf="donateTo" [modalMode]="true" [donateToData]="donateTo" (success)="onPickupRequestSuccess()"></app-pickup-request-form>
</ngx-smart-modal>
